if (document.querySelector('main.tn-receipt-page')) {
  let addedCalendarButton = false
  const performances = document.querySelectorAll('.tn-cart__section--performances .tn-cart__section-items .tn-cart-item-summary')

  if (performances.length) {
    performances.forEach((performance) => {
      let eventTitle = performance.querySelector('.tn-performance-title')
      eventTitle = eventTitle ? eventTitle.innerText : ''
      let eventLocation = performance.querySelector('.tn-cart-item-summary__property--location')
      eventLocation = eventLocation ? eventLocation.innerText : ''
      let dateTimeText = performance.querySelector('.tn-cart-item-summary__property--date-time')
      dateTimeText = dateTimeText ? dateTimeText.innerText : ''
      if (!eventTitle || !dateTimeText) return

      const eventDateTime = toDateTimeObject(dateTimeText)
      if (eventDateTime.date && eventDateTime.startTime && eventTitle.length) {
        addToCalendarCTA(performance, eventDateTime, eventTitle, eventLocation)
        addedCalendarButton = true
      }
    })
  }
  if (addedCalendarButton) {
    const script = document.createElement('script')
    script.src = 'https://cdn.jsdelivr.net/npm/add-to-calendar-button@2'
    document.head.appendChild(script)
  }
}

/**
   * Converts the date string into an object containing date (in ISO format),
   * startTime and endTime
   * @param {string} string
   * @returns Object
   */
function toDateTimeObject (text) {
  const plainDateTime = text.replace(/^.*?:\s*/, '') // Remove any leading text before the date
    .replace(/\u00A0/g, ' ') // Remove non-breaking spaces
    .replace('AM', ' AM')
    .replace('PM', ' PM')
    .trim()
  const dateObject = new Date(plainDateTime)

  if (dateObject !== 'Invalid Date') {
    // End date is required but we don't know the duration, so go with 2 hours
    const endTime = new Date(dateObject.getTime() + 2 * 3600 * 1000)
    return {
      date: dateObject.toISOString().slice(0, 10),
      startTime: dateObject.toLocaleTimeString('en-US', { hour12: false }),
      endTime: endTime.toLocaleTimeString('en-US', { hour12: false })
    }
  }

  return {}
}

/**
 * Append the add-to-calendar-button to the target element
 * @param {element} target
 * @param {object} dateTime
 * @param {string} title
 * @param {string} location
 */
function addToCalendarCTA (target, dateTime, title, location) {
  let listNode = document.createElement('li')
  listNode.className = 'tn-cart-item-summary__property'
  listNode.innerHTML = `<add-to-calendar-button
        name="${title}"
        description="This is an estimated run time. Please check your concert program closer to the concert date for the actual run time."
        location="${location}"
        startDate="${dateTime.date}"
        startTime="${dateTime.startTime}"
        endTime="${dateTime.endTime}"
        timeZone="America/Detroit"
        listStyle="dropdown-static"
        trigger="click"
        options="'Apple','Google','iCal','Outlook.com','Yahoo','Microsoft365'"
    ></add-to-calendar-button>`

    const dateLabel = target.querySelector('.tn-cart-item-summary__property--date-time');
    
    if (dateLabel) {
      dateLabel.insertAdjacentElement('afterend', listNode);
    } else {
      target.append(listNode);
    }
}
